import { render } from "./PageProduct.vue?vue&type=template&id=03b33478"
import script from "./PageProduct.vue?vue&type=script&lang=js"
export * from "./PageProduct.vue?vue&type=script&lang=js"

import "./PageProduct.vue?vue&type=style&index=0&id=03b33478&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__